import { Box, Divider, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import EmissionFactorTable from './components/EmissionFactorTable'
import { getEmissionFactors, postEmissionFactors } from '../../../../../actions/carbonfootprint-rework/07-emission-factors/01-emission-factors'

export default function EmissionFactors({ year, company, conversionFactor, category }) {
    const [formState, setFormState] = useState([])
    const [formError, setFormError] = useState(null)
    const [searchQuery, setSearchQuery] = useState('')
    const [currentPage, setCurrentPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalRows, setTotalRows] = useState(0)
    const dispatch = useDispatch()

    const emissionFactorsData = useSelector((state) => (state.emissionFactorsReducer?.emissionFactors?.data))
    const isLoading = useSelector((state) => (state.emissionFactorsReducer?.loading))
    const isPosting = useSelector((state) => (state.emissionFactorsReducer?.posting))
    const categoryName = category.name

    const filteredFormState = filterBySearchQuery()
    const paginatedForm = paginateForm(filteredFormState)

    useEffect(() => {
        if (emissionFactorsData) {
            setFormState(emissionFactorsData)
        }
    }, [emissionFactorsData])

    useEffect(() => {
        setTotalRows(filteredFormState?.length)
    }, [filteredFormState])

    useEffect(() => {
        setCurrentPage(0)
    }, [searchQuery, rowsPerPage])

    useEffect(() => {
        setSearchQuery('')
        setCurrentPage(0)
        resetFormError()
        dispatch(getEmissionFactors(company.id, year, categoryName))
    }, [category])

    const onSubmit = () => {
        try {
            validateForm(formState)
            dispatch(postEmissionFactors(formState, company.id, year, categoryName))
            resetFormError()
        } catch (error) {
            setFormError(error.message)
        }
    }

    function setData(event, factorId) {
        const { name, value } = event.target;
        setFormState((prevState) => {
            return prevState.map((row) =>
                row.id === factorId
                    ? { ...row, [name]: value }
                    : row
            )
        });
    }

    const handleSearch = (event) => {
        const queryText = event.target.value
        setSearchQuery(queryText)
    }

    function handleChangePage(event, page) {
        setCurrentPage(page)
    }

    function handleChangeRowsPerPage(event) {
        setRowsPerPage(event.target.value)
    }

    function validateForm(form) {
        form.map((formItem) => {
            const factorField = formItem['factor']
            const isNotNumber = isNaN(Number(factorField))

            if (isNotNumber && factorField !== null) {
                throw Error(`Entries in the Factor column must be real numbers.`)
            }
            if (factorField === '') {
                formItem['factor'] = null;
            }
        })
    }

    function filterBySearchQuery() {
        const filteredFormState = formState?.filter((row) => {
            const appActivityResults = row.app_activity.toLowerCase().includes(searchQuery.toLowerCase())
            const emissionSourceResults = row.emission_source.toLowerCase().includes(searchQuery.toLowerCase())
            // const defaultFactorResults = parseFloat(searchQuery) === row.default_factor
            const defaultFactorResults = row.default_factor?.toString().includes(searchQuery.toLowerCase())

            return appActivityResults || emissionSourceResults || defaultFactorResults
        })
        return filteredFormState
    }

    function resetFormError() {
        setFormError(null)
    }

    function paginateForm(form) {
        const startIndex = currentPage === 0 ? 0 : currentPage * rowsPerPage
        const endIndex = startIndex + rowsPerPage
        return form?.slice(startIndex, endIndex)
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Divider />
                <Typography variant='h5' component='h6' >
                    {`${conversionFactor} in ${category?.name} for ${year}`}
                </Typography>
            </Box>
            <EmissionFactorTable
                formState={paginatedForm}
                formError={formError}
                isLoading={isLoading}
                isPosting={isPosting}
                searchQuery={searchQuery}
                currentPage={currentPage}
                rowsPerPage={rowsPerPage}
                totalRows={totalRows}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleSearch={handleSearch}
                handleChange={setData}
                onSubmit={onSubmit} />
        </Box>
    )
}
